<template>
  <div>
    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-toolbar flat color="white">
      <v-toolbar-title>All Survey</v-toolbar-title>
        <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
       <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                    <v-card-title class="indigo white--text">
                        <div class="headline">Response Details</div>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">Task Id</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{editedItem.id}}</v-subheader>
                        </v-flex>
                        </v-layout>

                        <v-layout row>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">Project Id</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{editedItem.project_id}}</v-subheader>
                        </v-flex>
                        </v-layout>

                        <v-layout row>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">Dasher Id</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{editedItem.dasher_id}}</v-subheader>
                        </v-flex>
                        </v-layout>

                        <v-layout row>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">Task Starting Time</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">{{editedItem.started_at}}</v-subheader>
                        </v-flex>
                        </v-layout>

                        <v-layout row>
                        <v-flex xs6>
                            <v-subheader class="black--text font-weight-regular">Task Completed Time</v-subheader>
                        </v-flex>
                        <v-flex xs6>
                            <v-subheader class="black--text font-weight-regular">{{editedItem.completed_at}}</v-subheader>
                        </v-flex>
                        </v-layout>

                    </v-card-text>

                </v-card>

              <!-- <v-layout row justify-space-around>
                <v-flex xs6>
                  <v-card >
                      <v-card-text class="px-1">{{ (editedItem.outstanding) ? editedItem.outstanding : 0}}</v-card-text>
                  </v-card>
                </v-flex>
              </v-layout> -->  
            </v-container>
          </v-flex>
        </v-layout>
        <!-- <v-divider inset></v-divider> -->
        <v-container fluid>
          <v-layout row>
            <div>
              <v-btn color="success" @click="verifyItem(editedItem)">Accept</v-btn>
              <v-btn color="red" @click="close">Cancel</v-btn>
              <v-btn color="primary" @click="editItem(editedItem)">Modify</v-btn>
              <v-btn color="warning" @click="rejectItem(editedItem)">Reject</v-btn>
            </div>
          </v-layout>
        </v-container>
      </template>
    </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
     <div v-if="alertMsg">
        <v-alert v-if="error == 0 && statusCode == 200" :value="true" type="success" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 204" :value="true" type="info" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && (statusCode == 403 || statusCode == 400)" :value="true" type="warning" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 500" :value="true" type="error" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
     </div>
     <div v-if="indexData.datas.length < 1" class="text-xs-center">
       <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>

     </div>
    <v-data-table
      :headers="indexData.questions"
      :items="indexData.datas"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :loading="loading"
      class="elevation-1"
    >
     <!-- <v-progress-linear color="blue" indeterminate></v-progress-linear>
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              {{ props.header.text }}
            </span>
          </template>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template> -->
      
      <template v-slot:headers="props">
        <tr>
          <th align="left">Task Id</th>
          <th align="left">Project Id</th>
          <th align="left">Dasher Id</th>
          <th
          align="left"
          v-for="(header,index) in props.headers"
          :key="index"
          >
            {{ header.question }}
          </th>
          <th align="center">Actions</th>
        </tr>
      </template>
     
      <template v-if="indexData.datas.length > 0" v-slot:items="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.project_id }}</td>
        <td>{{ props.item.dasher_id }}</td>
        <td
        v-for="(header,index) in indexData.questions"
        :key="index"
        >{{ header.question_variable }}</td>
        <td class="justify-center layout px-1">
          <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="checkItem(props.item)">
                    visibility
                </v-icon>
              </template>
            <span>view</span>
          </v-tooltip>
        </td>
      </template>
      <template v-else v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          {{ errorMsg }}
        </v-alert>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
      <!-- <v-data-table
        :items="indexData.datas"
        class="elevation-1"
        hide-actions
        hide-headers  
      >
      <template v-slot:items="props">
        <tr>
          <td>Response ID</td>
          <td>Response ID</td>
          <td>Response ID</td>
          <td>Response ID</td>
          <td>Response ID</td>
        </tr>
      </template>
      </v-data-table> -->
    <template>
      <div class="text-xs-center">
        <v-pagination
          v-model="indexData.current_page"
          :length="indexData.last_page"
          @input="onPageChange"
        ></v-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      apiUrl: 'project',
      sl: 1,
      headers: [
        { text: 'Response Id', align: 'left', value: 'id' },
        { text: 'Project Id', align: 'left', value: 'project_id' },
        { text: 'Dasher Id', align: 'left', sortable: false, value: 'dasher_id' },
        { text: 'Task starting time', value: 'started_at' },
        { text: 'Task Completed Time', value: 'completed_at' },
        { text: 'Actions', align: 'center', value: 'name', sortable: false }
      ],
      loading: false,
      search: '',
      pagination: {},
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
      editedIndex: -1, 
      editedItem: {
        
      },
      defaultItem: {
        
      }
    }),
    
    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
    },

    watch: {
      // pagination() {
      //   this.onPageChange()
      // },
      dialog (val) {
        val || this.close()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
       initialize () {
        //  this.paginationMethod()
        let projectId = localStorage.getItem('projectId');
         this.$store.dispatch('getProjectResponse', [projectId, 'task'])
       
        // this.alertMsg = true
        // setTimeout(() => {
        //   this.alertMsg = false
        // }, 300)
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      checkItem (item) {
        // console.log(taskId)
        this.editedIndex = this.indexData.datas.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      verifyItem (item) {
        // console.log(item.id)
        // const index = this.indexData.indexOf(item)
        var popUpMsg = confirm('Are you sure you want to verify this application?') 
        if(popUpMsg){
          this.$store.dispatch('changeStatus',[ item.id, 'verify', this.routePath])
          item.project_status_id = 5
        }
        this.close()
      },

      editItem (item) {
        //  console.log(item)
        // this.editedIndex = this.indexData.indexOf(item)
        if (this.$refs.form.validate()) {
          this.snackbar = true
          
          var popUpMsg = confirm('Are you sure you want to permit for modification?') 
          if(popUpMsg){
            this.$store.dispatch('changeStatus',[ item.id, 'modify', this.routePath])
            item.project_status_id = 4
            this.comments.project_id=item.id
            this.$store.dispatch('store', ['comment', this.comments])
          }
          this.close()
        }

      },

      rejectItem (item) {
        // console.log(item.id)
        // const index = this.indexData.indexOf(item)
        var popUpMsg = confirm('Are you sure you want to reject this application?') 
        if(popUpMsg){
          this.$store.dispatch('changeStatus',[ item.id, 'reject', this.routePath])
          this.item.project_status_id = 3
        }
        this.close()
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },

      onPageChange(){
        this.paginationMethod()
      },

      paginationMethod() {
        this.loading = true
        
        if(this.search){
          this.$store.dispatch('indexData', ['project', 1, this.search, this.indexData.current_page, this.pagination.rowsPerPage])
          this.loading = (this.indexData.datas) ? false : true
        }else{
          this.$store.dispatch('indexData', ['project', 1, this.search, this.indexData.current_page, this.pagination.rowsPerPage])
          this.loading = (! this.indexData.error) ? false : true
        }
        this.dialog = false
      },
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>